import React, { Component } from "react";
import request from "../utils/request";
import moment from "moment";

import JackpotElements from "../components/jackpot/JackpotElements"

// Function to convert a string from snake_case or kebab-case to camelCase
function toCamelCase(str) {
  // The regular expression /([-_][a-z])/g matches any underscore or hyphen followed by a lowercase letter
  // The replace function changes these to the uppercase version of the letter
  return str.replace(/([-_][a-z])/g, g => g[1].toUpperCase());
}

// Function to convert all keys in an object from snake_case or kebab-case to camelCase
function convertKeysToCamelCase(obj) {
  // If the input is a string, try to parse it as JSON
  if (typeof obj === 'string') {
      try {
          obj = JSON.parse(obj);
      } catch (e) {
          // If parsing fails, return the original string
          return obj;
      }
  }

  // If the input is an array, convert all of its elements
  if (Array.isArray(obj)) {
      return obj.map(v => convertKeysToCamelCase(v));
  }
  // If the input is an object, convert all of its keys
  else if (obj !== null && obj.constructor === Object) {
      return Object.keys(obj).reduce(
          (result, key) => ({
              // Use the spread operator to add the previous keys to the new object
              // Convert the current key and add it to the new object
              ...result,
              [toCamelCase(key)]: convertKeysToCamelCase(obj[key])
          }),
          {}
      );
  }
  // If the input is neither a string, an array, nor an object, return it as is
  return obj;
}

class JackpotKiosk extends Component {
  constructor(props) {
    super(props);
    this.state = {
      background: {},
      elements: [],
      id: -1,
      eventId: 0,
      jackpot_localized: "0",
      prize_localized: "0",
      winner: "",
      has_addon: false,
      addon_jackpot_localized: "0",
      addon_prize_localized: "0",
      addon_winner: "",
      pollInterval: false,
      active: 1,
      dataSrc: "",
      initialized: false,
      jackpotReload: 0,
      jackpotIdFromUrl: 0,
      eventIdFromUrl: 0,
      defaultJackpotId: props.defaultJackpotId ? props.defaultJackpotId : 0,
      RaffleEvent: {
        Description: "",
        GrossSales: "",
        RaffleDate: "",
        WinAmount: "",
        WinTicket: "",
        CTAPrize: "",
        CTACard: "",
        CTAEnvelope: ""
      }
    }
  };
  componentDidMount = () => {
    this.getUrlParams();
  };
  componentDidUpdate = () => {
    if (!this.state.initialized) {
      this.setState({ initialized: true });
      if (+this.state.jackpotIdFromUrl !== -1) this.getData();
    }
  };
  // Strip query params from the url
  getUrlParams = () => {
    let urlParams = this.props.location.search;
    let params = {};
    let parts = urlParams.replace(/[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        params[key] = value;
      });
    let jackpotIdFromUrl = params['jackpotId'];
    let eventIdFromUrl = params['eventId'];
    if (+jackpotIdFromUrl === -1) {
      this.fetchJackpotScreens(this.state.defaultJackpotId);
    }
    this.setState({
      jackpotIdFromUrl: jackpotIdFromUrl,
      eventIdFromUrl: eventIdFromUrl
    }, () => this.getData());
  }
  fetchJackpotScreens = (screenId) => {
    request.get(this, `api:/jackpot/${screenId}`).then(jackpot => {
      this.setState({
        background: convertKeysToCamelCase(JSON.parse(jackpot.css)),
        elements: convertKeysToCamelCase(JSON.parse(jackpot.elements)),
        id: jackpot.id,
        active: +jackpot.active === 1 ? true : false,
        dataSrc: jackpot.data_src
      }, () => this.getExternalData());
    });
  }
  getExternalData = () => {
    let self = this;
    self.setState({ pollInterval: false }, clearInterval(this.state.pollInterval));
    let externalData = this.state.RaffleEvent;
    return request.getXML(this, `${this.state.dataSrc}`).then(resp => {

      let responseData = resp['RaffleEvent'];
      if (responseData['Description']) {
        externalData.Description = responseData['Description'] ? responseData['Description'][0] : "";
        externalData.GrossSales = responseData['GrossSales'] ? responseData['GrossSales'][0] : "";
        externalData.RaffleDate = responseData['RaffleDate'] ? responseData['RaffleDate'][0] : "";
        externalData.WinAmount = responseData['WinAmount'] ? responseData['WinAmount'][0] : "";
        externalData.WinTicket = responseData['WinTicket'] ? responseData['WinTicket'][0] : "";
      }
      else { // this supports locations with multiple
        Object.values(responseData).forEach(raffle => {

          if (raffle[0] !== '' &&  raffle[0]["IsActiveDisplay"] && raffle[0]['IsActiveDisplay'][0] === "1") {
            externalData.Description = raffle[0]['Description'] ? raffle[0]['Description'][0] : "";
            externalData.GrossSales = raffle[0]['GrossSales'] ? raffle[0]['GrossSales'][0] : "";
            externalData.RaffleDate = raffle[0]['RaffleDate'] ? raffle[0]['RaffleDate'][0] : "";
            externalData.WinAmount = raffle[0]['WinAmount'] ? raffle[0]['WinAmount'][0] : "";
            externalData.WinTicket = raffle[0]['WinTicket'] ? raffle[0]['WinTicket'][0] : "";
            return;
          } else if (raffle[0] !== '' && raffle[0]['CTAPrize'] ) {
            externalData.Description = raffle[0]['Description'] ? raffle[0]['Description'][0] : "";
            externalData.GrossSales = raffle[0]['GrossSales'] ? raffle[0]['GrossSales'][0] : "";
            externalData.RaffleDate = raffle[0]['RaffleDate'] ? raffle[0]['RaffleDate'][0] : "";
            externalData.WinAmount = raffle[0]['WinAmount'] ? raffle[0]['WinAmount'][0] : "";
            externalData.WinTicket = raffle[0]['WinTicket'] ? raffle[0]['WinTicket'][0] : "";
            externalData.CTAPrize = raffle[0]['CTAPrize'] ? raffle[0]['CTAPrize'][0] : "";
            externalData.CTACard = raffle[0]['CTACard'] ? raffle[0]['CTACard'][0] : "";
            externalData.CTAEnvelope = raffle[0]['CTAEnvelope'] ? raffle[0]['CTAEnvelope'][0] : "";
            return;

          } else if (raffle[0] !== '' && raffle[0]['Description'] )  {

            externalData.Description = raffle[0]['Description'] ? raffle[0]['Description'][0]  : "";
            externalData.GrossSales = raffle[0]['GrossSales'] ? raffle[0]['GrossSales'][0] : "";
            externalData.RaffleDate = raffle[0]['RaffleDate'] ?raffle[0]['RaffleDate'][0] : "";
            externalData.WinAmount = raffle[0]['WinAmount'] ? raffle[0]['WinAmount'][0] : "";
            externalData.WinTicket = raffle[0]['WinTicket'] ? raffle[0]['WinTicket'][0] : "";
            return;
          }

        });
      }

      this.setState({ RaffleEvent: externalData });
    }).then(() => {
      self.handlePoll();
    });
  }
  getData = () => {
    if (+this.state.jackpotIdFromUrl === -1) return;
    let self = this;
    self.setState({ pollInterval: false }, clearInterval(this.state.pollInterval));
    // Check for the post url w.r.t url param "eventId"
    let newUrl = (this.state.eventIdFromUrl) ? `web/event/${this.state.eventIdFromUrl}?persist_addons=1` : 'web/jackpot-event';
    let jackpotId = (this.state.jackpotIdFromUrl) ? this.state.jackpotIdFromUrl : null;
    return request
      .list(this, 'api:/' + newUrl)
      .then(resp => {
        if (resp.status === "error") return resp; // if error, then exit
        // Check for response
        let response = (this.state.eventIdFromUrl) ? resp : resp[0];
        let addon = response.addons.length > 0 ? response.addons[0] : false;

        // Check to see if reload required
        if (this.state.jackpotReload != 0 && response.jackpot_reload > this.state.jackpotReload) {
          window.location.reload();
        }

        response && this.setState({
          eventId: response.id > 0 ? response.id : 0,
          jackpot_localized: response.jackpot_localized,
          prize_localized: response.prize_localized,
          draw_date: moment(response.end_at).format("YYYY-MM-DD"),
          winner: response.draws[0].number,
          jackpotReload: response.jackpot_reload,
          addon_jackpot_localized: addon ? addon.jackpot_localized : '',
          addon_prize_localized: addon ? addon.prize_localized : '',
          addon_draw_date: addon ? moment(addon.end_at).format("YYYY-MM-DD") : '',
          addon_winner: addon ? addon.draws[0].number : null,
          has_addon: addon ? true : false
        }, () => {
          // Check for jackpot screen id passed through the url v/s the screen id from the response
          let jId = (jackpotId) ? jackpotId : response.jackpot_screen;
          if (this.state.id !== jId) {
            request.get(this, `api:/jackpot/${jId}`).then(jackpot => {
              this.setState({
                background: convertKeysToCamelCase(JSON.parse(jackpot.css)),
                elements: convertKeysToCamelCase(JSON.parse(jackpot.elements)),
                id: jackpot.id,
                active: +jackpot.active === 1 ? true : false,
                dataSrc: jackpot.data_src
              });
            });
          }
        })
      })
      .then(callbackResponse => {
        self.handlePoll(); // poll every 5 seconds
      });
  };
  handlePoll = () => {
    let recurringFunction = +this.state.jackpotIdFromUrl === -1 ? this.getExternalData : this.getData;
    if (!this.state.pollInterval) {
      let poll = setInterval(recurringFunction, 5000);
      this.setState({
        pollInterval: poll
      });
    }
  }
  render() {
    const { background, elements, jackpot_localized, prize_localized, winner, RaffleEvent, jackpotIdFromUrl, draw_date, addon_jackpot_localized, addon_prize_localized, addon_winner, addon_draw_date, has_addon } = this.state;
    let newElements = [];

    elements.map((v, k) => {
      let pusher = Object.assign({}, v);
      if (+jackpotIdFromUrl === -1) {
        /* XML Feed Jackpot Elements */
        if (v.label === "Raffle Date") pusher.content = RaffleEvent.RaffleDate ? RaffleEvent.RaffleDate : '';
        if (v.label === "Text") pusher.content = RaffleEvent.Description ? RaffleEvent.Description : '';
        if (v.label === "Jackpot") pusher.content = RaffleEvent.CTAPrize ? RaffleEvent.CTAPrize :  (RaffleEvent.GrossSales ? RaffleEvent.GrossSales : '');
        if (v.label === "Prize") pusher.content = RaffleEvent.WinAmount ? RaffleEvent.WinAmount : '';
        if (v.label === "Winning Number") pusher.content = RaffleEvent.WinTicket ? RaffleEvent.WinTicket : '';
        if (v.label === "Weekly Jackpot") pusher.content = RaffleEvent.WinAmount ? RaffleEvent.WinAmount : '';
        if (v.label === "Winning Number" && (RaffleEvent.WinTicket === "" || RaffleEvent.WinTicket === null) && v.hideCaptionUntilDraw) return true;
      } else {
        if (v.label === "Jackpot") pusher.content = jackpot_localized ? jackpot_localized : '';
        if (v.label === "Prize") pusher.content = prize_localized ? prize_localized : '';
        if (v.label === "Weekly Jackpot") pusher.content = prize_localized ? prize_localized : '';
        if (v.label === "Winning Number") pusher.content = winner;
        if (v.label === "Raffle Date") pusher.content = draw_date ? draw_date : '';
        if (v.label === "Winning Number" && (winner === "" || winner === null) && v.hideCaptionUntilDraw) return true;

        if (v.label.startsWith("Addon ")) {
          if (!has_addon) {
            // only display these elements if event has an addon
            return true;
          }

          if (v.label === "Addon Jackpot") pusher.content = addon_jackpot_localized ? addon_jackpot_localized : '';
          if (v.label === "Addon Prize") pusher.content = addon_prize_localized ? addon_prize_localized : '';
          if (v.label === "Addon Raffle Date") pusher.content = addon_draw_date ? addon_draw_date : '';
          if (v.label === "Addon Winning Number") pusher.content = addon_winner;
          if (v.label === "Addon Winning Number" && (addon_winner === "" || addon_winner === null) && v.hideCaptionUntilDraw) return true;
        }
      }
      return newElements.push(pusher);
    });

    return (
      <JackpotElements background={background} elements={newElements} />
    );
  }
}

export default JackpotKiosk;
